export default __webpack_public_path__ + "static/media/limb_medium@2x.17d4fe9d.jpg";